module.exports = __webpack_public_path__ + "static/img/no-pic.63b14c58.jpg";